import { useCallback }      from "react";
import { dispatcher }       from "../store";
import { useStoreSelector } from "./redux/useStoreSelector";
import { useNotify }        from "./system/useNotify";
import { useApi }           from "./useApi";
import {useProfile}         from "./useProfile";

export function useCredit(clientId?: number) {
  const {client} = useProfile(),
        {api, isAuth} = useApi(),
    credit = useStoreSelector( s => s.credit.list),
    {addNotify, handleApiError} = useNotify()
 
  const loadCredit = useCallback(async (client_id?: number) => {
    if (isAuth) {
        if( client_id ) {
            api.getCredit({client_id: client_id})
               .then(handleApiError)
               .then((body) => {
                   if (body) {
                       console.log('body=', body)
                       dispatcher.credit.setCredit(body[0])
                   }
               }).catch(e => addNotify('error', 'Error', e.message))
        } else if (client && client.id) {
            api.getCredit({client_id: client.id})
               .then(handleApiError)
               .then((body) => {
                   if (body) {
                       console.log('body=', body)
                       dispatcher.credit.setCredit(body[0])
                   }
               }).catch(e => addNotify('error', 'Error', e.message))
        }

  }}, [api, handleApiError, isAuth])

  return {credit, loadCredit}
}
